<app-input-select-controlli-costum
  idField="uuid"
  labelField="uuid"
  [list]="puntiCampionamento"
  [name]="name"
  label="Punto di Campionamento"
  icon="pin_drop"
  [form]="form"
  [searchComponentTemplate]="searchTemplate"
  (datoSelected)="chekDataSelected($event)"
></app-input-select-controlli-costum>
